var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59739 22.7547C3.59739 12.1747 12.1718 3.59798 22.751 3.59798C33.3302 3.59798 41.9046 12.1738 41.9046 22.7547C41.9046 33.3357 33.3302 41.9115 22.751 41.9115C12.1718 41.9115 3.59739 33.3357 3.59739 22.7547ZM14.6817 21.951H21.9474V14.6841C21.9474 14.2408 22.3069 13.8804 22.751 13.8804C23.1951 13.8804 23.5546 14.2408 23.5546 14.6841V21.951H30.8203C31.2644 21.951 31.6239 22.3105 31.6239 22.7547C31.6239 23.198 31.2644 23.5584 30.8203 23.5584H23.5546V30.8244C23.5546 31.2686 23.1951 31.6281 22.751 31.6281C22.3069 31.6281 21.9474 31.2686 21.9474 30.8244V23.5584H14.6817C14.2376 23.5584 13.8781 23.1989 13.8781 22.7547C13.8781 22.3105 14.2376 21.951 14.6817 21.951ZM22.751 5.20537C13.06 5.20537 5.20452 13.0621 5.20452 22.7547C5.20452 32.4473 13.0591 40.3041 22.751 40.3041C32.4429 40.3041 40.2975 32.4491 40.2975 22.7547C40.2975 13.0621 32.442 5.20537 22.751 5.20537ZM22.751 0C10.1861 0 0 10.1877 0 22.7547C0 35.3217 10.1861 45.5094 22.751 45.5094C35.3168 45.5094 45.502 35.3226 45.502 22.7547C45.502 10.1877 35.3159 0 22.751 0Z",
    fill: "#4A3A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCell);
export default __webpack_public_path__ + "static/media/button_cell.6c0b0860d927a5eeea4618830af65adf.svg";
export { ForwardRef as ReactComponent };